import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';

const root = ReactDOM.createRoot(document.getElementById('root'));
axios.defaults.baseURL = process.env.REACT_APP_IDM_BACKEND_URL
// axios.defaults.baseURL = "http://localhost:/pmsidm"
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

